import React from "react";
import { useObserver } from "mobx-react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowRight, FileUpload } from "mdi-material-ui";
import { Body, PlainLink, PrimaryButton, RegularButton } from "@components";
import { ThemeType } from "@theme";
import locale from "@bonliva-crm/locale";
import { DnDLocalContainer } from "@containers/DnDContainer";
import { ConsultantImportStore } from "../ConsultantImportStore";

export type UploadProps = {
  store: ConsultantImportStore;
};

export function Upload(props: UploadProps) {
  const { store } = props;
  const classes = useStyles({});

  return useObserver(() => (
    <div className={classes.wrapper}>
      <DnDLocalContainer
        noClick
        accept={store.uploadConfig.acceptTypes}
        onDrop={(files) => store.setFile(files[0])}
      >
        <Paper className={classes.root}>
          <div>
            <div>
              <Body>{locale.DragAndDropOrSelect}</Body>
              <br />
              <PlainLink href="/assets/media/import_lead_template.xlsx">
                {locale.DownloadTemplateFile}
              </PlainLink>
            </div>

            <div className={classes.actions}>
              {!store.file && (
                <PrimaryButton
                  style={{ marginLeft: "auto" }}
                  leftIcon={<FileUpload fontSize="small" />}
                  onClick={store.selectFile}
                >
                  {locale.SelectFile}
                </PrimaryButton>
              )}

              {store.file && (
                <RegularButton
                  variant="text"
                  style={{ marginLeft: "auto" }}
                  leftIcon={<FileUpload fontSize="small" />}
                  onClick={store.selectFile}
                >
                  {locale.SelectAnotherFile}
                </RegularButton>
              )}

              <PrimaryButton
                onClick={store.processFile}
                disabled={!store.isFileSelected}
                rightIcon={store.file ? <ArrowRight fontSize="small" /> : null}
              >
                {locale.ImportFile(store.file ? store.file.name : "")}
              </PrimaryButton>
            </div>
          </div>
        </Paper>
      </DnDLocalContainer>
    </div>
  ));
}

const useStyles = makeStyles((theme: ThemeType) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },

  root: {
    ...theme.mixins.childrenMarginBottom(16),
    align: "flex-start",
    marginBottom: "10%",
    padding: 16,
    textAlign: "center",
    width: "40rem"
  },

  actions: {
    ...theme.mixins.childrenMarginRight(8),
    display: "flex",
    alignItems: "flex-end"
  }
}));
